module.exports = new __parcel__URL__("settings_connect_wallet_button.8a101441.png").toString();